export const iconFontAwesomeCodingBug = (
	<i className="fa-solid fa-bug"></i>
);
